import LinearProgress from "@mui/material/LinearProgress"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"

interface IProps {
  done: number
  total: number
  label?: string
}

const DeterminateProgress = ({ done, total, label }: IProps) => {
  const value = total > 0 ? Math.min(100, (done / total) * 100) : 0
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress variant="determinate" value={value} />
        </Box>
        <Box sx={{ minWidth: 60 }}>
          <Typography variant="body2" color="text.secondary">{`${done} / ${total}`}</Typography>
        </Box>
      </Box>
      {label && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {label}
        </Typography>
      )}
    </Box>
  )
}

export default DeterminateProgress
